import mediaQuery from '@/lib/styling/mediaQuery';
import CommentCreatedAt from './CommentCreatedAt';
import { type UserSummary } from '@/lib/types';
import styled from '@emotion/styled';
import UserAvatar from '@/components/UserAvatar';

const AuthorInfoWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  [mediaQuery(860)]: {
    lineHeight: 1,
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  h4: {
    color: theme.palette.text.primary,
    fontWeight: 500,
    fontSize: 15,
    [mediaQuery(860)]: {
      marginBottom: 4,
    },
  },
}));

type CoachCommentAuthorProps = {
  author: UserSummary;
  commentCreatedAt: string;
};

const CoachCommentAuthor = ({
  author,
  commentCreatedAt,
}: CoachCommentAuthorProps) => (
  <>
    <UserAvatar user={author} size={28} marginRight={12} />
    <AuthorInfoWrapper>
      <h4>{author.name}</h4>
      <CommentCreatedAt createdAt={commentCreatedAt} />
    </AuthorInfoWrapper>
  </>
);

export default CoachCommentAuthor;
